const baseList = require("badwords/array");
const localList = require("./local-badwords.json").words;

class Filter {
  /**
   * Filter constructor.
   * @constructor
   * @param {object} options - Filter instance options
   * @param {boolean} options.emptyList - Instantiate filter with no blacklist
   * @param {array} options.list - Instantiate filter with custom list
   * @param {string} options.splitRegex - Regular expression used to split string into words.
   * @param {string} options.sanitizeRegex - Regular expression used to sanitize words before comparing them to blacklist.
   * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
   * @param {string} options.placeHolder - Character used to replace profane words.
   */
  constructor(options = {}) {
    Object.assign(this, {
      list:
        (options.emptyList && []) ||
        Array.prototype.concat.apply(localList, [baseList, options.list || []]),
      exclude: options.exclude || [],
      splitRegex: options.splitRegex || /\s/, // Split on whitespace
      sanitizeRegex: options.sanitizeRegex || /\W|_|\^/g, // Sanatize out non-word characters
      replaceRegex: options.replaceRegex || /\w/g, // Replace all word characters
      placeHolder: options.placeHolder || "*"
    });
  }

  /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */
  isProfane(string) {
    return this.list.find(word => {
      const wordExp = new RegExp(`${word.replace(/(\W)/g, "\\$1")}`, "gi");
      return (
        !this.exclude.includes(word) && wordExp.test(this.sanitize(string))
      );
    }) !== undefined
      ? true
      : false;
  }

  /**
   * Split's the given string into this filter's definition of words based upon splitRegex.
   * @param {string} string - String to split into words.
   */
  words(string) {
    return string.split(this.splitRegex);
  }

  /**
   * Return a sanatized version of the given word based upon sanitizeRegex.
   * @param {string} word - Word to sanitize.
   */
  sanitize(word) {
    return word.replace(this.sanitizeRegex, "");
  }

  /**
   * Evaluate a string for profanity and return the bad words.
   * @param {string} string - Sentence to filter.
   */
  badWords(string) {
    return this.words(string).filter(word => {
      return this.isProfane(word);
    });
  }

  /**
   * Replace a word with placeHolder characters;
   * @param {string} string - String to replace.
   */
  replaceWord(string) {
    return this.sanitize(string).replace(this.replaceRegex, this.placeHolder);
  }

  /**
   * Evaluate a string for profanity and return an edited version.
   * @param {string} string - Sentence to filter.
   */
  clean(string) {
    return this.words(string)
      .map(word => {
        return this.isProfane(word) ? this.replaceWord(word) : word;
      })
      .join("");
  }

  /**
   * Add word(s) to blacklist filter / remove words from whitelist filter
   * @param {...string} word - Word(s) to add to blacklist
   */
  addWords() {
    let words = Array.from(arguments);

    this.list.push(...words);

    words.forEach(word => {
      if (this.exclude.includes(word)) {
        this.exclude.splice(this.exclude.indexOf(word), 1);
      }
    });
  }

  /**
   * Add words to whitelist filter
   * @param {...string} word - Word(s) to add to whitelist.
   */
  removeWords() {
    this.exclude.push(...Array.from(arguments));
  }
}

// module.exports = Filter;
export default Filter;
